import { Team } from "../../types";
import { playInsGroup1, playInsGroup2 } from "./teams";

export const initialPlayInsQualifiedTeams: Team[] = [
    playInsGroup1[0],
    playInsGroup1[3],
    playInsGroup2[0],
    playInsGroup2[1],
]